import React, { useEffect } from "react";
import "./Notification_Page.css";
import { useDispatch, useSelector } from "react-redux";
import { getAllNotification } from "../../features/admin/vendor_expert/Slice";

const Notification_Page = () => {
  const dispatch = useDispatch();

  const all_notification = useSelector(
    (state) => state?.vendor_expert?.vendorexperts?.allnotification,
  );

  useEffect(() => {
    dispatch(getAllNotification());
  }, [dispatch]);

  // helper function for date & time
  const formatDateTime = (dateString) => {
    const dateObj = new Date(dateString);

    const date = dateObj.toLocaleDateString("en-GB"); // DD/MM/YYYY
    const time = dateObj.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    return { date, time };
  };

  return (
    <section className="Notification_Page">
      <div className="container">
        <div className="notification_container">
          {all_notification?.data?.length > 0 ? (
            all_notification.data.map((item, index) => {
              const { date, time } = formatDateTime(item.created_at);

              return (
                <div className="notification_card" key={index}>
                  <div className="notification_left">
                    <h4 className="title">{item.sub_type}</h4>

                    <p
                      className="subtitle"
                      dangerouslySetInnerHTML={{ __html: item.message }}
                    ></p>
                  </div>

                  <div className="notification_right">
                    <p className="date">{date}</p>
                    <p className="time">{time}</p>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="no_notification">
              <p>No Notification Found</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Notification_Page;
